import request from "utils/request";

import { baseRequestURL, constructQueryParams } from "api/BaseAPI";

export function postDeploy(jobId, modelName, options) {
  const body = options || {};
  body.model_name = modelName;
  return request(baseRequestURL + "v1/job/" + jobId + "/deploy", {
    method: "POST",
    body: JSON.stringify(body)
  }).then((response) => response);
}

export function cancelDeploy(deployId) {
  return request(baseRequestURL + "v1/deployment/" + deployId + "/cancel", {
    method: "POST",
    body: JSON.stringify({})
  }).then((response) => response);
}

export function stopDeploy(deployId) {
  return request(baseRequestURL + "v1/deployment/" + deployId, {
    method: "DELETE"
  }).then((response) => response);
}

export function getDeploy(deployId) {
  return request(baseRequestURL + "v1/deployment/" + deployId, {
    method: "GET"
  }).then((response) => response);
}

export function getAllDeploy(userId) {
  const queryArr = [
    // ((userId || userId === 0) ? "created_by=" + userId : "")
  ];
  const queryURL = baseRequestURL + "v1/deployments" + constructQueryParams(queryArr);
  return request(queryURL, {
    method: "GET"
  }).then((response) => response);
}

export function scoreDeploy(endpoint, rows, headers = {}, options = {}) {
  return request(endpoint, {
    method: "POST",
    body: JSON.stringify({
      data: rows,
      options: {
        ...options
      }
    }),
    headers: headers
  }).then((response) => response);
}

export function pollDeploy(endpoint, headers = {}) {
  return request(endpoint, {
    method: "POST",
    headers: headers
  }).then((response) => response);
}
